import { getRegion, getCaid, getLocale, getDomain, getConfigurationObject } from '@/data/regionInfo';
import returnQueryParams from "@/http/returnQueryParams";
import addUrlParams from "@/http/addUrlParams";

const QUERY_PARAMS_ALLOWED = ['icn', 'source'];

export default {
  data() {
    return {
      modalStyles: {
        minHeight: 'auto'
      },
    }
  },
  computed: {
    noEsiActive() {
      return this.$store.getters['utils/noEsiActive'];
    },
    vsfActive() {
      return this.$store.getters['utils/vsfActive'];
    },
    canvasActive() {
      return this.$store.getters["utils/canvasActive"];
    }
  },
  methods: {
    adjustModalHeight() {
      const useParentHeight = this.$store.getters['utils/noEsiActive']
        && this.$store.getters['utils/isIframeSameOrigin']
        && this.$store.getters["utils/returnScreenSize"].includes('mobile');

      this.modalStyles = {
        ...this.modalStyles,
        height: `${ useParentHeight ? window.parent.innerHeight : window.innerHeight }px`,
      };

      const el = document.querySelector(".ugcentrypoint-modal") || document.querySelector(".randomizer-modal");
      if(useParentHeight && el && el.style.height==='0px') {
        el.style.height = `${ useParentHeight ? window.parent.innerHeight : window.innerHeight }px`;
        el.style.width = '100%';
      }
    },
    setupCaid({params}) {
      const configObject = getConfigurationObject() || {};

      if(params.caid) {
        this.$store.commit('utils/SET_CAID', params.caid);
        this.$store.commit('utils/SET_CONFIGURATION', { region: getRegion(), locale: getLocale(), domain: params.domainName || `https://${getDomain()}`});
      }

      const domain = (!this.domain && configObject && configObject.domain) ? configObject.domain : this.domain || process.env.VUE_APP_DOMAIN;
      const locale = getLocale();
      const region = getRegion();

      if (!params.caid && region && locale && domain) {
        this.$store.commit('utils/SET_CONFIGURATION', { region, locale, domain });
        this.$nextTick(() => {
          this.$store.commit('utils/SET_CAID', getCaid().caid);
        });
      }
    },
    filterKeysObj(obj1, obj2){
      const keysObj1 = Object.keys(obj1);
      const keysObj2 = Object.keys(obj2);
      for (let key of keysObj2) {
        if (!keysObj1.includes(key)) {
          obj1[key] = obj2[key]
        }
      }
      return obj1;
    },
    persistQueryParams(url, extraParams) {
      const queryParams = returnQueryParams();
      let filteredParams = {};
      for (let item of QUERY_PARAMS_ALLOWED) {
        if (item in queryParams) {
          filteredParams[item] = queryParams[item]
        }
      }

      if(extraParams) filteredParams = this.filterKeysObj(filteredParams, extraParams);

      return addUrlParams(url, filteredParams);
    },
    // UGC Entry Point Methods
    async generatePlacementComponent(ugcComponent) {
      const feature = this.$store.state.UGCEntryPoint.feature;
      const ugcTemp = await this.$store.dispatch(
        "UGCEntryPoint/GENERATE_UGC_SWATCH", {
          size: this.selectedSize,
          imageBuffer: this.$parent.$refs[`${ugcComponent}PlacementImage`][0].src,
          ugcComponent,
          croppedPlacement: this.$parent.croppedPlacement[ugcComponent]
        });
        if(this.enablePerformanceLogging)
            console.log("UGC Swatch Generated: ", new Date().getTime() / 1000 - this.initialTime);

      this.$recipe.updateUGC(ugcComponent, ugcTemp, (feature ? feature : null) );
    },
    /**
     * @function generateRecipeId
     * Generates the recipe id and redirects to customizer including
     * recipe in the query params. {customizer.model.html?recipe=recipeId}
     */
    async generateRecipeId() {
      const { pdm, selectedStyle, selectableStyles, enableAutoColorMapping } = this.$store.state.UGCEntryPoint;
      if (this.crayolaActive) {
        this.$ugcEntryPointDataLayer.logAnalyticsEvent({
          action: this.getAction(),
          type: this.$ugcEntryPointDataLayer.types.customize
        });
      }

      await this.$store.dispatch("recipe/GET_RECIPE", {
        recipe_id: pdm[selectedStyle].default_recipe,
        type: 'ugcentrypoint',
        setData: true
      }, { root: true });

      await this.generatePlacementComponent(selectableStyles[selectedStyle].ugc_component_name);

      if (selectableStyles[selectedStyle].secondary_ugc_component_name) {
        await this.generatePlacementComponent(selectableStyles[selectedStyle].secondary_ugc_component_name);
      }

      if (enableAutoColorMapping) {
        await this.updateRecipeColorMapping(selectedStyle);
      }

      if (this.useEcomDataLayerFormat) {
        this.$ugcEntryPointDataLayer.logAnalyticsEvent({
          action: this.getAction(),
          type: this.$ugcEntryPointDataLayer.types.continueToCustomizer
        });
      }
      if(this.imageLibraryId && this.imageLibraryCategory) {
        const toolKitObject = {
          image_library_id: this.imageLibraryId,
          image_library_category: this.imageLibraryCategory
        };
        const ugcComp =  this.$recipe.getUGCComponents();
        ugcComp.forEach((componentName) => {
          const data = this.$store.state.recipe.recipe_v2.components[componentName];
          data.subgroup = "library";
          data.toolkit_options = toolKitObject;
          this.$store.commit("recipe/UPDATE_COMPONENT", { componentName, data });
        })
      }

      this.$store
        .dispatch("recipe/SAVE_RECIPE", {
          recipe: this.$store.state.recipe.recipe_v2,
          requestParams: { locale: getLocale() },
          type: 'ugcentrypoint'
        }, { root: true })
        .then(({ recipeId }) => {
          const selectedStyle = this.$store.state.UGCEntryPoint.selectedStyle;
          if(this.enablePerformanceLogging)
            console.log("Recipe Saved: ", new Date().getTime() / 1000 - this.initialTime);

          let url = this.canvasActive ? 
          `${this.$store.getters["utils/baseUrl"]("ugcentrypoint")}/${getLocale().replace("_","-")}/customizer/${ selectedStyle }?recipe=${ recipeId }` :
          `${this.$store.getters["utils/baseUrl"]("ugcentrypoint")}/customizer.${ selectedStyle }.html?recipe=${ recipeId }`;
          if (this.imageLibraryId && this.imageLibraryCategory) { url+="&imageLibrary=true" }
          if(this.canvasActive ) {
            window.parent.location = this.persistQueryParams(url, { source: this.$store.state.UGCEntryPoint.source});
          } else {
            window.location = this.persistQueryParams(url, { source: this.$store.state.UGCEntryPoint.source});
          }

        })
        .catch(error => console.error(`Error generating the recipe id ${error}`))
        .finally(() => {
            this.isLoading = false;
        });
    },
    /**
     * Gets the components that need to be updated from combinations & swatches in color mapping response
     *
     */
    updateRecipeColorMapping(selectedModel) {
      const colorMaps = this.$store.state.UGCEntryPoint.colorMappingData;
      const combinationsMaps = colorMaps && colorMaps.combinations && colorMaps.combinations.find(({model}) => model === selectedModel);
      const combination = Object.keys(combinationsMaps).length > 0 && combinationsMaps.components;

      const swatchesAvailable = colorMaps && colorMaps.available_swatches;

      Object.keys(combination).forEach(component => {
        const recipeComponent = this.$store.state.recipe.recipe_v2.components[component];
        const swatch = swatchesAvailable.find(({swatch_id}) => swatch_id === combination[component]);
        if ((swatch && swatch.swatch_id) && recipeComponent) {
          this.applyRecipeSwatchMapping(swatch, recipeComponent, component);
        }
      });
    },

    /**
     * Updates the recipe components' swatch
     */
    applyRecipeSwatchMapping(swatch, componentObj, componentName) {
      if(swatch.swatch_id !== componentObj.swatch_id) {
        this.$store.dispatch("recipe/UPDATE_RECIPE_COMPONENT",{
          componentName,
          swatchId: swatch.swatch_id,
          group: swatch.group,
          subgroup: swatch.subgroup,
          material_type: swatch.material_type
        });
      }
    }
  },
  created() {
    window.addEventListener('resize', this.adjustModalHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustModalHeight);
  }
};
